module.exports = __webpack_public_path__ + "img/MyTransactions.5bbf47ec.png";